import { Bone, SHIMMER_STYLE } from "@ui/Molecules/Skeleton/Bone";

export function PlaceListRowSkeleton({ size = "md" }: { size?: "sm" | "md" }) {
	const dim = size === "sm" ? 48 : { w: 76, h: 96 };
	return (
		<>
			<style>{SHIMMER_STYLE}</style>
			<div className="flex items-center gap-3.5 border-t border-[var(--border-subtle)] py-3.5 first:border-t-0">
				<Bone
					style={{
						width: typeof dim === "number" ? dim : dim.w,
						height: typeof dim === "number" ? dim : dim.h,
					}}
					radius="var(--radius-sm)"
				/>
				<div className="flex flex-1 flex-col gap-2">
					<Bone width="55%" height={14} />
					<Bone width="40%" height={12} />
					{size === "md" && <Bone width="65%" height={12} />}
				</div>
			</div>
		</>
	);
}
